import type { Area, OrganizacionAdmin, UsuarioAdmin } from "@/lib/types";
import { SeccionNombre } from "./SeccionNombre";
import { SeccionRoles } from "./SeccionRoles";
import { SeccionAreas } from "./SeccionAreas";
import { SeccionOrganizaciones } from "./SeccionOrganizaciones";

/**
 * Panel expandible con las sub-secciones editables del usuario (nombre, roles,
 * áreas, organizaciones). Cada sección maneja su propia mutation y state local ·
 * independientes entre sí, así un cambio de roles no afecta lo que aún no se
 * guardó en áreas. El nombre va arriba, a todo el ancho.
 */
export function PanelEdicionUsuario({
  u,
  todasAreas,
  todasOrganizaciones,
}: {
  u: UsuarioAdmin;
  todasAreas: Area[];
  todasOrganizaciones: OrganizacionAdmin[];
}) {
  return (
    <div className="flex flex-col gap-4">
      <SeccionNombre usuarioId={u.id} nombreActual={u.fullName} email={u.email} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <SeccionRoles usuarioId={u.id} rolesActuales={u.roles} />
        <SeccionAreas usuarioId={u.id} areasActuales={u.areas} todasAreas={todasAreas} />
        <SeccionOrganizaciones usuarioId={u.id} organizacionesActuales={u.organizaciones} todasOrganizaciones={todasOrganizaciones} />
      </div>
    </div>
  );
}
